const AnimationSpeedEnum = {
    Slow: "Slow",
    Medium: "Medium",
    Fast: "Fast"
}
export default AnimationSpeedEnum;